<!-- eslint-disable vue/valid-v-for -->
<!--
 * @Description: 
 * @Author: luckymiaow
 * @Date: 2022-04-29 15:13:52
 * @LastEditors: luckymiaow
-->
<script lang="ts" setup>
import { computed, useAttrs } from 'vue';
import useForm from '../../form/src/useFormConfig';
import type { EnumRadioProps } from '../types';
import { Radio, RadioButton, RadioGroup } from '../../radio';

import useEnum from './useEnum';

interface Props extends EnumRadioProps {
  radioType?: 'radio' | 'button';
  enum: object;
  /* 排除选项的枚举值 */
  excludeOptions?: any[];
  /* 指定选项的枚举值 */
  appointOptions?: any[];
}

const props = withDefaults(defineProps<Props>(), {
  radioType: 'radio',
});

const { options } = useEnum({ props });

const { getBindValue } = useForm<EnumRadioProps & EnumRadioProps>({
  props,
  componentName: 'EnumRadio',
  attrs: useAttrs(),
});

const componentName = computed(() => {
  if (props.radioType === 'button') return RadioButton;
  else return Radio;
});
</script>

<template>
  <RadioGroup v-bind="getBindValue">
    <component :is="componentName" v-for="item in options" :key="item.value" :value="item.value">{{
      item.label
    }}</component>
  </RadioGroup>
</template>
